import { render, staticRenderFns } from "./PersonaEmailForm.vue?vue&type=template&id=43991712&scoped=true"
import script from "./PersonaEmailForm.vue?vue&type=script&lang=js"
export * from "./PersonaEmailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43991712",
  null
  
)

export default component.exports